import { render } from "./SummaryLease.vue?vue&type=template&id=38e820b8&ts=true"
import script from "./SummaryLease.vue?vue&type=script&lang=ts"
export * from "./SummaryLease.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__